export const REPORT_HEADER_DATA = {
    VIDEO: {
        title: "Report Post",
        subtitle: "Why are you reporting this post?  ",
    },
    COMMENT: {
        title: "Report Comment",
        subtitle: "Why are you reporting this comment?",
    },
}

export const REPORT_REASON_DATA = [
    "Inappropriate content",
    "Non-professional content",
    "Spam",
    "Threatening, violent or suicidal",
    "Other"
]